export const CarouselIds = {
  LIVE: "video-carousel",
  TRENDING: "video-trending-carousel",
  DAILY_MOST_WATCHED: "video-daily-watched-carousel",
};
